import React from "react";
import ProductTable from "./ProductTable";

const ProductList = () => {
  return (
    <div className="bg-white rounded-lg shadow w-full h-full overflow-auto p-4">
      <ProductTable />
    </div>
  );
};

export default ProductList;